import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routes } from "routes";
import NotFound from "views/errors/404";

export default function Member(props) {
    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.layout === "/member") {
                return (
                    <Route path={`${prop.path}`} element={prop.component} key={key} />
                );
            }

            return null;
        });
    };
    document.documentElement.dir = "ltr";

    return (
        <div className="h-full w-full bg-lightPrimary dark:bg-background-900 dark:text-white">
            {/* Navbar & Main Content */}
            <div className="h-full w-full m-auto sm:max-w-[390px] font-dm">
                {/* Main Content */}
                <main className="flex-none transition-all">
                    {/* Routes */}
                    <div className="flex flex-col mx-auto min-h-screen">
                        <Routes>
                            {getRoutes(routes)}
                            <Route
                                path="/"
                                element={<Navigate to="/volunteer/my-services" replace />}
                            />
                            <Route path="*" element={<NotFound/>} />
                        </Routes>
                    </div>
                </main>
            </div>
        </div>
    );
}
